import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  href?: string;
}
export const WHATSAPP_URL = 'https://wa.me/5492995192151?text=%C2%A1Hola!%20Vi%20la%20web%20y%20quiero%20reservar%20un%20turno';
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  className = '',
  href,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-sans font-medium tracking-wide rounded-full transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-rosegold focus:ring-offset-2 focus:ring-offset-nude';
  const variants = {
    primary: 'btn-liquid text-white',
    outline: 'border border-rosegold text-rosegold hover:bg-rosegold hover:text-white',
    ghost: 'text-deepblack hover:text-rosegold hover:bg-rosegold/10'
  };
  const sizes = {
    sm: 'px-6 py-2 text-sm',
    md: 'px-8 py-3 text-base',
    lg: 'px-10 py-4 text-lg'
  };
  const classes = `${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`;
  if (href) {
    return <a href={href} target="_blank" rel="noopener noreferrer" className={classes} data-id="element-221">
        {children}
      </a>;
  }
  return <motion.button whileTap={{
    scale: 0.98
  }} className={classes} {...props} data-id="element-222">
      {children}
    </motion.button>;
}